export default __webpack_public_path__ + "static/media/portfolio_myImg.d767b627.png";